import { getUrlWithSchema } from "@shared/common/utils/url";
import fetch from "isomorphic-unfetch";
import type { ExternalSiteRule } from "../../types";
import { SHOPBY_PAGE, SITE_TYPE } from "./const";

const INVALID_SITE_INFO = "INVALID";

async function hasSiteModule(host: string, path: string) {
  const url = `${host}${path}`;
  try {
    const ret = await fetch(url);
    //./js/module/appinfo.js body 내용에 Unexpected token / in JSON at position 0 문제가 발생하므로 통신상태가 정상인지만 확인하고 끝냄
    if (ret.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    throw new Error(`${url} fetch error! ${err}`);
  }
}

const shopby: ExternalSiteRule = {
  type: SITE_TYPE,

  getInfo: async ({ html, responseUrl }) => {
    if (!html.innerHTML.includes("./js/module/appinfo.js")) {
      return INVALID_SITE_INFO;
    }

    const result = await hasSiteModule(responseUrl, "config/deploy.js");

    if (!result) {
      return INVALID_SITE_INFO;
    }

    return {
      siteType: SITE_TYPE,
      url: responseUrl,
      siteInfo: {
        type: SITE_TYPE,
      },
    };
  },

  pageRules: [
    {
      siteType: SITE_TYPE,
      targetValue: SHOPBY_PAGE.LOGIN.target,
      label: "로그인 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${SHOPBY_PAGE.LOGIN.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SHOPBY_PAGE.MY_PAGE.target,
      label: "마이 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${SHOPBY_PAGE.MY_PAGE.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SHOPBY_PAGE.SIGNUP.target,
      label: "가입하기 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${SHOPBY_PAGE.SIGNUP.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SHOPBY_PAGE.FIND_ID.target,
      label: "아이디 찾기 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${SHOPBY_PAGE.FIND_ID.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SHOPBY_PAGE.FIND_PASSWORD.target,
      label: "비밀번호 찾기 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${SHOPBY_PAGE.FIND_PASSWORD.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SHOPBY_PAGE.CART.target,
      label: "장바구니 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${SHOPBY_PAGE.CART.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SHOPBY_PAGE.POLICY.target,
      label: "이용약관 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${SHOPBY_PAGE.POLICY.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SHOPBY_PAGE.PRIVACY.target,
      label: "개인정보처리방침 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${SHOPBY_PAGE.PRIVACY.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SHOPBY_PAGE.PRODUCT_DETAIL.target,
      label: "상품 상세 페이지",
      getExactUrl({ siteUrl, params }) {
        if (params?.productSlug) {
          return `${getUrlWithSchema(siteUrl)}${
            SHOPBY_PAGE.PRODUCT_DETAIL.url
          }?${params.productSlug}`;
        }
        return `${getUrlWithSchema(siteUrl)}${
          SHOPBY_PAGE.PRODUCT_DETAIL.url
        }?...`;
      },
      allowDuplicate: true,
      params: [
        {
          key: "productSlug",
          formType: "TEXT",
          placeholder: "/하위경로를 입력해주세요",
        },
      ],
    },
  ],
};

export default shopby;
